export const classes = {
  tab: 'p-4 h-full',
  card: 'py-4 px-0 h-full',
};
